/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecialitySeoPage
 */
export interface SpecialitySeoPage {
    /**
     * 
     * @type {string}
     * @memberof SpecialitySeoPage
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecialitySeoPage
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecialitySeoPage
     */
    searchUrl?: string;
}

/**
 * Check if a given object implements the SpecialitySeoPage interface.
 */
export function instanceOfSpecialitySeoPage(value: object): value is SpecialitySeoPage {
    return true;
}

export function SpecialitySeoPageFromJSON(json: any): SpecialitySeoPage {
    return SpecialitySeoPageFromJSONTyped(json, false);
}

export function SpecialitySeoPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialitySeoPage {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'url': json['url'] == null ? undefined : json['url'],
        'searchUrl': json['searchUrl'] == null ? undefined : json['searchUrl'],
    };
}

export function SpecialitySeoPageToJSON(value?: SpecialitySeoPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'url': value['url'],
        'searchUrl': value['searchUrl'],
    };
}

